const INVOICE_STATUS = {
  PAID: "paid",
  OPEN: "open",
  DRAFT: "draft",
  VOID: "void",
  UNCOLLECTIBLE: "uncollectible",
  REFUNDED: "refunded",
};

export default INVOICE_STATUS;
